import { toggle } from "./toggle";

export default toggle("hide-enabled");
